import { ReactNode } from 'react';
import { Empty, lucideIcons } from '@round/creatorbase-ui';
import { OutreachResultsEmptyStateVariant } from './helpers';
import styles from './OutreachResultsEmptyState.module.css';

const { CircleAlert, SearchX, UserSearch, Users } = lucideIcons;

const GENERIC_ERROR_MESSAGE = 'Results could not be loaded.';

type Props = {
    variant: OutreachResultsEmptyStateVariant;
    errorMessage?: string | null;
};

export const OutreachResultsEmptyState = ({ variant, errorMessage }: Props) => (
    <div className={styles.container}>
        <Empty className={styles.empty}>{getVariantContent({ variant, errorMessage })}</Empty>
    </div>
);

function getVariantContent({ variant, errorMessage }: Props): ReactNode {
    switch (variant) {
        case 'collecting':
            return (
                <>
                    <Empty.Media variant="icon">
                        <UserSearch />
                    </Empty.Media>
                    <Empty.Title>Still collecting</Empty.Title>
                    <Empty.Description>Creators appear here as they are collected.</Empty.Description>
                </>
            );
        case 'noneFound':
            return (
                <>
                    <Empty.Media variant="icon">
                        <Users />
                    </Empty.Media>
                    <Empty.Title>No creators found</Empty.Title>
                    <Empty.Description>
                        This request finished without finding creators for its targets and filters.
                    </Empty.Description>
                </>
            );
        case 'noMatches':
            return (
                <>
                    <Empty.Media variant="icon">
                        <SearchX />
                    </Empty.Media>
                    <Empty.Title>No matching creators</Empty.Title>
                    <Empty.Description>
                        No creators match the current tab and filters. Clear or widen them to see more.
                    </Empty.Description>
                </>
            );
        case 'error':
            return (
                <>
                    <Empty.Media variant="icon">
                        <CircleAlert />
                    </Empty.Media>
                    <Empty.Title>Something went wrong</Empty.Title>
                    <Empty.Description>{errorMessage || GENERIC_ERROR_MESSAGE}</Empty.Description>
                </>
            );
    }
}
